import { globalAxios } from "@/axios-path.js";
// fetchCustomerReport;
export default {
  namespaced: true,
  state: {
    config_path: {
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    clone_config_path: {
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    order_customer_report_list: [],
    customer_report_list: [],
    export_customer_report_list: [],
    export_order_customer_report_list: [],
  },
  mutations: {
    resetState(state) {
      state.config_path = {
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.clone_config_path = {
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.order_customer_report_list = [];
      state.customer_report_list = [];
      state.export_customer_report_list = [];
      state.export_order_customer_report_list = [];
    },
    getOrderCustomerList(state, data) {
      state.order_customer_report_list = data;
      let counter_customer = 1;
      for (let val of state.order_customer_report_list) {
        let order_store_temp = "";
        for (let val1 of val.order_store) {
          let index = val.order_store.indexOf(val1);
          order_store_temp += val1;
          if (index < val.order_store.length - 1) {
            order_store_temp += ",";
          }
        }
        val.order_store_temp = order_store_temp;
        if (val.order_code) {
          val.no = counter_customer++;
          val.no_default = counter_customer - 1;
        } else {
          val.no = null;
          val.no_default = counter_customer - 1;
        }
      }
    },
    getCustomerListReport(state, data) {
      state.customer_report_list = data;
      let counter_customer = 1;
      for (let val of state.customer_report_list) {
        let counter_order = 0;
        if (val.user_full_name) {
          val.no = counter_customer++;
          val.no_default = counter_customer - 1;
        } else {
          val.no = null;
          val.no_default = counter_customer - 1;
        }
        counter_order += val.order_food;
        counter_order += val.order_mess;
        counter_order += val.order_free;
        val.customer_counter_order = counter_order;
      }
    },
    getExportFormOrderCustomer(state) {
      state.export_order_customer_report_list = [];
      let counter_customer_no = 1;
      for (let val of state.order_customer_report_list) {
        let order_store = [];
        for (let val1 of val.order_store) {
          order_store.push(val1);
        }
        let json_push = {
          no: val.order_code ? counter_customer_no++ : null,
          order_code: val.order_code,
          order_base_code: val.order_base_code,
          order_store: order_store,
          order_price: val.order_price,
          order_rider_full_name: val.order_rider_full_name,
        };
        state.export_order_customer_report_list.push(json_push);
      }
    },
    getExportFormCustomer(state) {
      state.export_customer_report_list = [];
      let counter_customer_no = 1;
      for (let val of state.customer_report_list) {
        let json_push = {
          no: val.user_full_name ? counter_customer_no++ : null,
          user_full_name: val.user_full_name,
          user_tel: val.user_tel,
          user_point:
            typeof val.user_point == "number"
              ? parseFloat(val.user_point)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          user_order_count:
            val.order_food + "," + val.order_free + "," + val.order_mess,
        };
        state.export_customer_report_list.push(json_push);
      }
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
  },
  actions: {
    async fetchReportListByDistrict({ rootState, commit, state, dispatch }) {
      let url =
        "/api/v1/" +
        rootState.backOffice.province +
        "/search_by_district/customer_report/datetime_start/datetime_end/" +
        state.config_path.datetime_start +
        "/" +
        state.config_path.datetime_end;

      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("cloneConfigPath");
          commit("getCustomerListReport", res.data);
          commit("getExportFormCustomer");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchReportList({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchCustomerReport_fetchReportList +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("cloneConfigPath");
        commit("getCustomerListReport", res.data);
        commit("getExportFormCustomer");
      }
    },
    async fetchOrderCustomerListtByDistrict(
      { rootState, commit, state, dispatch },
      config
    ) {
      let url =
        "/api/v1/" +
        rootState.backOffice.province +
        "/search_by_district/customer_detail_report/customer_id/datetime_start/datetime_end/" +
        config.customer_id +
        "/" +
        config.order_start +
        "/" +
        config.order_end;

      let payload = {
        district: config.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("getOrderCustomerList", res.data);
          commit("getExportFormOrderCustomer");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getOrderCustomerList({ commit, rootState, dispatch }, config) {
      let url =
        rootState.api_urls.fetchCustomerReport_getOrderCustomerList +
        config.customer_id +
        "/" +
        config.order_start +
        "/" +
        config.order_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return;
      } else {
        commit("getOrderCustomerList", res.data);
        commit("getExportFormOrderCustomer");
        return;
      }
    },
  },
  getters: {},
};
